if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;

        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));

        this.cart =
          document.querySelector('cart-notification') ||
          document.querySelector('cart-drawer');

        this.submitButton = this.querySelector('[type="submit"]');

        this.isPreorder = this.dataset.preorder === 'true';

        this.setButtonText();

        if (document.querySelector('cart-drawer')) {
          this.submitButton.setAttribute('aria-haspopup', 'dialog');
        }

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      // 🔥 FORZAR TEXTO DEL BOTÓN SIEMPRE
      setButtonText() {
        if (!this.submitButton) return;

        const span = this.submitButton.querySelector('span');

        if (!span) return;

        if (this.isPreorder) {
          span.textContent = 'Pre-Order';
        } else {
          span.textContent = 'Add to cart';
        }
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);

        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }

        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              this.handleErrorMessage(response.description);
              this.error = true;
              return;
            }

            if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error) {
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            }

            this.error = false;

            if (this.cart.classList.contains('is-empty')) {
              this.cart.classList.remove('is-empty');
            }

            this.cart.renderContents(response);
          })
          .catch((e) => console.error(e))
          .finally(() => {
            this.submitButton.classList.remove('loading');

            if (!this.error) {
              this.submitButton.removeAttribute('aria-disabled');
            }

            this.querySelector('.loading__spinner').classList.add('hidden');

            // 🔥 RE-FORZAR TEXTO DESPUÉS DE VARIANTES (CLAVE)
            this.setButtonText();
          });
      }

      handleErrorMessage(message = false) {
        if (this.hideErrors) return;

        const wrapper = this.querySelector('.product-form__error-message-wrapper');
        if (!wrapper) return;

        const messageEl = wrapper.querySelector('.product-form__error-message');

        wrapper.toggleAttribute('hidden', !message);

        if (message) {
          messageEl.textContent = message;
        }
      }
    }
  );
}